module.exports = __webpack_public_path__ + "media/loop_warm.35756d94.mp4";